import { isAdminSite, isWebView } from '../helpers';

export const mixpanelIdentityPath = {
  companyUrl: ['@@store.auth.company.url', window.location.host],
  companyName: ['@@store.auth.company.id'],
  userId: ['@@store.auth.id'],
  projectType: isAdminSite() ? 'Admin' : 'WebLearner',
  inWebView: isWebView(),
  orgId: ['@@store.auth.company.orgId'],
  superlogin: ['@@store.auth.superlogin'],
  companyType: ['@@store.auth.company.companyType'],
};

var globalMixpanelIdentity = {
  moduleName: {
    name: 'module_name',
  },
  moduleType: {
    name: 'module_type',
  },
  moduleId: {
    name: ['module_id'],
  },
  seriesId: {
    name: 'series_id',
  },
  seriesName: {
    name: 'series_name',
  },
  companyUrl: {
    name: 'learning_site',
  },
  companyName: {
    name: 'cname',
  },
  userId: {
    name: 'user_id',
  },
  projectType: {
    name: 'project_type',
  },
  orgId: {
    name: 'org_id',
  },
  superlogin: {
    name: 'superlogin',
  },
  companyType: {
    name: 'learning_site_type',
  },
  assetType: {
    name: 'asset_type',
  },
  inWebView: {
    name: 'in_web_view',
  },
  zoom_integration_enabled: {
    name: 'zoom_integration_enabled',
  },
};

export const mixpanelIdentity = {
  set: identity => {
    globalMixpanelIdentity = { ...globalMixpanelIdentity, ...identity };
  },
  get: () => globalMixpanelIdentity,
};
